import { Router } from "@angular/router";
import { IBranch } from "src/app/interfaces/branch";
import { SoundEnum } from "src/app/enums/sound.enum";
import { IConfirm } from "src/app/interfaces/confirm";
import { TranslateService } from "@ngstack/translate";
import { ErrorsService } from "src/app/services/common/errors.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatDialog,
  MatTableDataSource,
  MatSort,
  MatPaginator
} from "@angular/material";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { BranchEntryComponent } from "./branch-entry/branch-entry.component";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { CIDService } from "src/app/services/common/cid.service";

@Component({
  selector: "app-branch",
  templateUrl: "./branch.component.html",
  styleUrls: ["./branch.component.css"]
})
export class BranchComponent implements OnInit {
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "code",
    "name",
    "province",
    "city",
    "status",
    "function"
  ];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  data: IBranch;
  pageSize: number;
  pageIndex: number;
  companyEncryptCode: string;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private branchService: BranchService
  ) { }

  ngOnInit() {
    this.list();
  }
  list() {
    this.branchService.list(false, 1, 10).subscribe(
      res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      },
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("error.listShow", {
            name: this.translate.get("label.branch")
          }),
          "OK",
          5000,
          SoundEnum.beep
        );
      }
    );
  }


  ative(data: any): void {
    let confirm: IConfirm = {
      accept: true,
      message: data.StatusCode == 'Active'
        ? this.translate.get("confirm.inActive", {
          name: this.translate.get("label.branch") + " " + data.Name
        })
        : this.translate.get("confirm.active", {
          name: this.translate.get("label.branch") + " " + data.Name
        }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      let model = {
        BranchEncryptId: data.BranchEncryptId,
        StatusId: data.StatusCode == 'Active' ? 21 : 20
      }
      if (result) {
        this.branchService.changeStatus(model).subscribe(
          () => {
            this.referesh();
          },
          () => {
            this.errorService.transactionError();
          }
        );
      }
    });
  }

  paginatorEvent(event) {
    this.branchService
      .list(false, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.paginator.length = res.Total;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
      });
  }

  referesh() {
    this.branchService
      .list(false, this.pageIndex, this.pageSize)
      .subscribe(res => {
        this.paginator.length = res.Total;
        this.dataSource = new MatTableDataSource(res.DataList);
      });
  }

  add(): void {
    this.dialog
      .open(BranchEntryComponent, {
        width: "750px",
        data: this.cidService.getCID()
      })
      .afterClosed()
      .subscribe(() => {
        this.branchService.list().subscribe(re => {
          this.paginator.pageIndex = 0;
          this.dataSource = re.DataList;
          this.paginator.length = re.Total;
        });
      });
  }

  // edit(data: IBranch): void {
  //   const dialogRef = this.dialog
  //     .open(BranchEntryComponent, {
  //       width: "750px",
  //       data: data
  //     })
  //     .afterClosed()
  //     .subscribe(res => {
  //       this.branchService.list(this.pageIndex, this.pageSize).subscribe(re => {
  //         this.dataSource = res.DataList;
  //         this.paginator.length = re.Total;
  //       });
  //     });
  // }
  edit(data: IBranch) {
    this.dialog
      .open(BranchEntryComponent, {
        width: "750px",
        data: data
      })
      .afterClosed()
      .subscribe(() => {
        this.branchService.list(false, this.pageIndex, this.pageSize).subscribe(re => {
          this.dataSource = re.DataList;
          this.paginator.length = re.Total;
        });
      });
  }

  setRoom(e) {
    this.router.navigate([
      "/management/basic/company/branch/roomList/" + e.BranchEncryptId
    ]);
  }

  delete(data: IBranch): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.branch") + " " + data.Name
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var model = {
          EncryptId: data.BranchEncryptId
        }
        this.branchService.delete(model).subscribe(
          () => {
            this.branchService
              .list(false, this.pageIndex, this.pageSize)
              .subscribe(re => {
                this.dataSource = re.DataList;
                this.paginator.length = re.Total;
              });
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  // ngOnDestroy() {
  //   this.cidService.setCID("");
  // }
}
